import { Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Link } from 'foundations-components/transitional/components/Link';
import ErrorBoundary from 'conversations-error-reporting/error-boundaries/components/ErrorBoundary';
import AssigneeFilter from './AssigneeFilter';
import StatusFilter from './StatusFilter';
import ChannelFilter from './ChannelFilter';
import ContactFilter from './ContactFilter';
import DateFilter from './DateFilter';
import TrashToggle from './TrashToggle';
import FilteredToggle from './FilteredToggle';
import { useFilterValues } from 'find-and-filter-data/search-and-filter-data/public';
import { DEFAULT_CHAT_FILTERS } from 'find-and-filter-data/search-and-filter-data/protected';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { getClickedClearFilter } from 'conversations-inbox-lib/usage-tracking/inboxInteractionEvents';
import { VIEW_SELECTOR_FULL_WIDTH } from 'svh-workspace-ui-lib/collapsable-sidebar/public';
import InboxExitSearchAndFilterMode from './InboxExitSearchAndFilterMode';
import { ChannelInstanceIdFilter } from './ChannelInstanceIdFilter';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterSidebar = () => {
  const {
    clearFilterValues,
    filterValues
  } = useFilterValues();
  const handleClearFilterValues = () => {
    clearFilterValues();
    trackEvent(getClickedClearFilter());
  };
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    errorLoggingTitle: "FilterSidebar",
    children: /*#__PURE__*/_jsxs(View, {
      paddingBlockEnd: "500",
      paddingInlineStart: "500",
      paddingInlineEnd: "500",
      borderInlineEndStyle: "solid",
      borderInlineEndColor: "border-core-subtle",
      borderInlineEndWidth: "100",
      inlineSize: `${VIEW_SELECTOR_FULL_WIDTH}px`,
      children: [/*#__PURE__*/_jsx(InboxExitSearchAndFilterMode, {}), /*#__PURE__*/_jsxs(TFlex, {
        direction: "row",
        children: [/*#__PURE__*/_jsx(TFlex, {
          align: "start",
          children: /*#__PURE__*/_jsx(Text, {
            as: "h5",
            color: "text-core-default",
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-inbox-ui.thread-search-and-filtering.filter-sidebar.title"
            })
          })
        }), /*#__PURE__*/_jsx(TFlex, {
          align: "end",
          justify: "end",
          children: /*#__PURE__*/_jsx(Link, {
            onClick: handleClearFilterValues,
            disabled: filterValues.delete('searchQuery').equals(DEFAULT_CHAT_FILTERS.delete('searchQuery')),
            "data-test-id": "search-and-filtering-clear-all",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-inbox-ui.thread-search-and-filtering.filter-sidebar.filter-options.clear"
            })
          })
        })]
      }), /*#__PURE__*/_jsx(StatusFilter, {}), /*#__PURE__*/_jsx(ChannelFilter, {}), /*#__PURE__*/_jsx(ChannelInstanceIdFilter, {}), /*#__PURE__*/_jsx(ContactFilter, {}), /*#__PURE__*/_jsx(AssigneeFilter, {}), /*#__PURE__*/_jsx(DateFilter, {}), /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "small",
          display: "inline-block",
          marginBlockStart: "600",
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-ui.thread-search-and-filtering.filter-sidebar.filter-options.moreOptions"
          })
        }), /*#__PURE__*/_jsx(FilteredToggle, {}), /*#__PURE__*/_jsx(TrashToggle, {})]
      })]
    })
  });
};
FilterSidebar.displayName = 'FilterSidebar';
export default FilterSidebar;